import type { Experience } from '../experience'
import { markLoadPhase, measureLoadPhase } from '../loadPerformance'
import { unmountShellRoot } from '../shellRoot'
import { bundleForExperience, fetchUnifiedManifest } from './unifiedManifest'

function injectStyles(hrefs: string[]): void {
  for (const href of hrefs) {
    if (document.querySelector(`link[data-unified-css="${href}"]`)) continue
    const link = document.createElement('link')
    link.rel = 'stylesheet'
    link.href = href
    link.dataset.unifiedCss = href
    document.head.appendChild(link)
  }
}

export async function loadExperienceApp(experience: Experience): Promise<void> {
  markLoadPhase('experience-load-start')
  const manifest = await fetchUnifiedManifest()
  const bundle = bundleForExperience(manifest, experience)
  injectStyles(bundle.css)
  markLoadPhase('experience-import-start')
  unmountShellRoot()
  await import(/* @vite-ignore */ bundle.entry)
  markLoadPhase('experience-import-done')
  measureLoadPhase('experience-import', 'experience-import-start', 'experience-import-done')
  measureLoadPhase('experience-load', 'experience-load-start', 'experience-import-done')
  markLoadPhase('shell-experience-ready')
}
